// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "input[data-v-4c0b4354]::-webkit-outer-spin-button,\ninput[data-v-4c0b4354]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\ninput[type=number][data-v-4c0b4354] {\n  -moz-appearance: textfield;\n}\n.patient-info-edit > a[data-v-4c0b4354] {\n  color: #984422;\n}", ""]);
// Exports
module.exports = exports;
